
import { QueryClient } from "@tanstack/react-query";
import { Fund } from "@/types/fund";

export function getFundQueryKey(fundId: string) {
  return ['fund', fundId] as const;
}

export async function handleOptimisticUpdate(
  queryClient: QueryClient,
  fundId: string,
  newImageUrl: string | null
) {
  const queryKey = getFundQueryKey(fundId);
  await queryClient.cancelQueries({ queryKey });
  const previousData = queryClient.getQueryData<Fund>(queryKey);

  // Optimistically update the fund data
  queryClient.setQueryData<Fund>(queryKey, (old) => {
    if (!old) return old;
    return {
      ...old,
      fund_image_url: newImageUrl
    };
  });

  return { previousData };
}

export function revertOptimisticUpdate(
  queryClient: QueryClient,
  fundId: string,
  previousData: Fund | undefined
) {
  const queryKey = getFundQueryKey(fundId);
  if (previousData) {
    queryClient.setQueryData(queryKey, previousData);
  }
}
